import React from 'react';
import { Route, IndexRoute } from 'react-router';
import Loadable from 'react-loadable';

import CircleLoader from 'ggApp/shared/components/CircleLoader';
import { PaymentsModuleConnectedWrap } from 'ggApp/shared/screens/PaymentMethods/PaymentsModuleContext/PaymentsModuleWrap';

const Loading = (): JSX.Element => <CircleLoader />;

const Wrap = Loadable({
    loader: () => import(/* webpackChunkName: "YourProfileWrap" */ './wrap'),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const PaymentMethodListPage = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "ManagePaymentMethods" */ 'ggApp/shared/screens/Payments/pages/PaymentMethodListPage'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const PaymentMethodDetailsPage = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "ManagePaymentMethods" */ 'ggApp/shared/screens/Payments/pages/PaymentMethodDetailsPage'
        ),
    loading: Loading,
    delay: 300,
    timeout: 10000,
});

const AddPaymentMethod = Loadable({
    loader: () =>
        import(
            /* webpackChunkName: "AddPaymentMethod" */ 'ggApp/shared/screens/PaymentMethods/AddNewPaymentMethod'
        ),
    loading: () => <CircleLoader />,
    delay: 300,
    timeout: 10000,
    render(loaded: any, props: any): React.ReactNode {
        const Component = loaded.default;
        return <PaymentsModuleConnectedWrap component={Component} {...props} />;
    },
});

const YourProfileRoutes = (): JSX.Element => (
    <Route path="payments">
        <Route path="payment-methods" component={Wrap}>
            <IndexRoute component={PaymentMethodListPage} />
            <Route path="add" component={AddPaymentMethod} />
            <Route path=":paymentMethodId" component={PaymentMethodDetailsPage} />
        </Route>
    </Route>
);

export default YourProfileRoutes;
